export const DEBOUNCE_OPTIONS = {
  DELAY: 500,
  LOADER_DELAY: 100,
  MIN_LENGTH: 3,
};
